<template>
  <div class="language-container">
    <span class="language-title" @click="switchLang">{{ lang === 'en' ? '简体中文' : 'English' }}</span>
  </div>
</template>

<script>

import moment from 'moment'
import { mapActions } from 'vuex'

export default {
  data () {
    return {
    }
  },
  computed: {
    lang () {
      return this.$i18n.locale
    }
  },
  methods: {
    ...mapActions('common', ['changeLanguage']),
    async switchLang () {
      const current = moment.locale()
      let locale = 'en'
      if (this.lang === 'en') {
        locale = 'zh-cn'
      }
      this.$i18n.locale = this.lang === 'zh' ? 'en' : 'zh'
      this.changeLanguage(this.$i18n.locale === 'en' ? 'en' : 'zh-cn')
      if (locale !== current) {
        moment.locale(locale)
        this.$eventBus.$emit('momentLocaleChange')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.language-container {
  width: 100%;
  text-align: right;
  padding: 20px 0 0 0;

  .language-title {
    color: #0096cc;
    margin-right: 10px;
    cursor: pointer;
  }
}
</style>
